/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

export const deleteOption = createAsyncThunk(
  'products/deleteOption',
  async ({ productId, optionId }, {
    extra: { Logger, Toast, sdk },
  }) => {
    try {
      const { data } = await sdk.products.deleteOption(productId, optionId);
      return data;
    } catch (error) {
      Toast(
        'Option is not deleted. Refresh and try again',
        { autoClose: false, type: 'error' },
      );
      Logger.error(new Error('Error option deleting'), { error }, [
        'DeleteOptionFailed',
        'Option is not deleted on the backend.',
      ]);
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder.addCase(
    deleteOption.pending,
    (state, { meta }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = true;
        }
      });
    },
  ).addCase(
    deleteOption.fulfilled,
    (state, { payload }) => {
      state.items = state.items.map((product) => {
        if (product._id === payload._id) return { ...product, isBusy: false, ...payload };
        return product;
      });
    },
  ).addCase(
    deleteOption.rejected,
    (state, { meta, error }) => {
      state.items.forEach((product) => {
        if (product._id === meta.arg.productId) {
          product.isBusy = false;
        }
      });
      state.error = error;
    },
  );
};
